module.exports = __webpack_public_path__ + "static/img/team_bj_mid_icon.4764e34e.png";